import emitEvent from '@/entrypoints/helpers/cartChangeEvent';
import fetchConfig from '@/entrypoints/helpers/fetchConfig';

export default class ProductForm extends HTMLElement {
    constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.productId = this.form.querySelector('input[name="id"]');
        this.variantCtas = this.form.querySelectorAll('.js-add-variant-to-bag');
        this.cartNotification = document.querySelector('cart-notification');

        this.initEventListeners();
    }

    onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains('loading')) return;

        this.handleErrorMessage();
        this.cartNotification.setActiveElement(document.activeElement);

        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        this.submitForm();
    }

    initEventListeners() {
        this.variantCtas.forEach(element => {
            element.addEventListener("click", (evt) => {
                evt.preventDefault()
                this.productId.value = element.dataset.vid;
                this.submitForm();
            })
        });
    }

    submitForm() {
        const submitButton = this.querySelector('[type="submit"]');
        const config = fetchConfig.init('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;
        let error = false;

        fetch(`${window.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    this.handleErrorMessage(response.description);
                    error = true;
                    return;
                }

                emitEvent.emitEvent(response);
                this.cartNotification.renderContents(response);
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
                if(submitButton) {
                    submitButton.classList.remove('loading');
                    submitButton.removeAttribute('aria-disabled');
                }

                if(!error) {
                    this.handleQuickAddModal();
                }

                if(this.querySelector('.loading-overlay__spinner')) {
                    this.querySelector('.loading-overlay__spinner').classList.add('hidden');
                }

            });
    }

    handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
        }
    }

    handleQuickAddModal() {
        const quickAddModal = document.querySelector('quick-add-modal.is-active');
        if(quickAddModal && quickAddModal.classList.contains('is-active')) {
            quickAddModal.hide()
        }
    }
}
